<template>
  <div class="flex flex-row items-start justify-start">
    <GoBackLink :to="backUrl" class="mr-4 mt-[-0.35rem]" />
    <div class="flex flex-col gap-2">
      <ProductName>
        {{ productName }}
        <template v-if="productColor" #below>{{ productColor }}</template>
      </ProductName>
      <BazaarVoice :id="product.id" show="rating_summary" class="h-6" />
      <ProductBadges
        :product="product"
        :selected-variant="selectedVariant"
        class="h-5"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Product, Variant } from '@scayle/storefront-nuxt'
import { useGlasses } from '~/composables/pdp/useGlasses'

const props = defineProps({
  backUrl: {
    type: String as PropType<string>,
    required: true,
  },
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
  selectedVariant: {
    type: Object as PropType<Variant>,
    default: undefined,
  },
})

const $i18n = useI18n()
const { productColor } = useGlasses(ref(props.product))

const productName = computed(() =>
  getProductName(props.product, $i18n.t('wishlist.product')),
)
</script>
